/**
 * Splide スライダー初期化（要素が存在する場合のみ）
 * Splide は common.js で window.Splide に格納済み
 */
import { truncateTopVoiceQuotes } from './top-voice-quote.js';
import { initBukkenDetailMainCaption } from './bukken-detail-main-caption.js';
import { completeTopMvMountForIntro, isTopIntroPending } from './top-intro.js';

export function init() {
	// トップMVスライダー（フェード・自動再生）
	const topMvEl = document.querySelector('.js-top-mv-slider');
	if (topMvEl) {
		const topMvBars = topMvEl.querySelectorAll('.topMv__bar');
		const topMvIntroPending = isTopIntroPending();
		const topMvSlider = new window.Splide(topMvEl, {
			type: 'fade',
			rewind: true,
			speed: 600,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: !topMvIntroPending,
			interval: 4000,
			pauseOnHover: true,
			// lazyLoad は初回フェード時に隣スライドの準備が遅れジャッキーになりやすい（MV は3枚・マークアップは loading=eager のため不要）
		});
		topMvSlider.on('moved', function (newIndex) {
			topMvBars.forEach(function (bar, i) {
				const isCurrent = i === newIndex;
				bar.classList.toggle('topMv__bar--current', isCurrent);
				bar.setAttribute('aria-current', isCurrent ? 'true' : 'false');
			});
		});
		topMvBars.forEach(function (bar) {
			bar.addEventListener('click', function () {
				topMvSlider.go(Number(bar.dataset.index));
			});
		});
		const decodeTopMvImages = function () {
			const imgs = topMvEl.querySelectorAll('img');
			return Promise.all(
				Array.from(imgs).map(function (img) {
					return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
				}),
			);
		};
		decodeTopMvImages().finally(function () {
			topMvSlider.mount();
			completeTopMvMountForIntro(function () {
				if (topMvIntroPending && topMvSlider.Components.Autoplay) {
					topMvSlider.Components.Autoplay.play();
				}
			});
		});
	}

	// ミラクラスMVスライダー（フェード・自動再生）
	const miraclasMvEl = document.querySelector('.js-miraclas-mv-slider');
	if (miraclasMvEl) {
		const miraclasMvSlider = new window.Splide(miraclasMvEl, {
			type: 'fade',
			rewind: true,
			speed: 600,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});

		const decodeMiraclasImages = function () {
			const imgs = miraclasMvEl.querySelectorAll('img');
			return Promise.all(
				Array.from(imgs).map(function (img) {
					return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
				}),
			);
		};

		decodeMiraclasImages().finally(function () {
			miraclasMvSlider.mount();
		});
	}

	// ミラクラス 物件事例（SPのみチラ見スライダー）
	const miraclasCaseEl = document.querySelector('.js-miraclas-case-slider');
	if (miraclasCaseEl) {
		const isSp = window.matchMedia('(max-width: 767px)').matches;
		if (isSp) {
			const miraclasCaseSlider = new window.Splide(miraclasCaseEl, {
				type: 'loop',
				rewind: false,
				perPage: 1,
				perMove: 1,
				gap: '5%',
				padding: { left: '8.5%', right: '8.5%' },
				pagination: true,
				arrows: false,
				speed: 500,
				autoplay: true,
				interval: 4000,
				pauseOnHover: true,
			});
			miraclasCaseSlider.mount();

			const caseSection = miraclasCaseEl.closest('.miraclasCase');
			const prevBtn = caseSection ? caseSection.querySelector('.bukkenList__cardArrow--prev') : null;
			const nextBtn = caseSection ? caseSection.querySelector('.bukkenList__cardArrow--next') : null;
			if (prevBtn) prevBtn.addEventListener('click', function () { miraclasCaseSlider.go('<'); });
			if (nextBtn) nextBtn.addEventListener('click', function () { miraclasCaseSlider.go('>'); });
		}
	}

	// wantedlyWorks スライダー（5枚・タブなし・自動再生）
	const wantedlyWorksEl = document.querySelector('.js-wantedly-works-slider');
	if (wantedlyWorksEl) {
		const wantedlyWorksSlider = new window.Splide(wantedlyWorksEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});
		wantedlyWorksSlider.mount();
	}

	// 強みカード CH スライダー
	const strongSliderEl = document.querySelector('.js-strong-slider');
	const strongTabs = document.querySelectorAll('.js-strong-tab');
	if (strongSliderEl && strongTabs.length) {
		const strongSlider = new window.Splide(strongSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: false,
			autoplay: true,
			interval: 3000,
			pauseOnHover: true,
		});

		// CH タブクリックでスライド切替
		strongTabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				strongSlider.go(Number(tab.dataset.index));
			});
		});

		// スライド変更でタブのアクティブ状態を同期
		strongSlider.on('moved', function (newIndex) {
			strongTabs.forEach(function (tab, i) {
				const isActive = i === newIndex;
				tab.classList.toggle('topStrong__chTab--current', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
		});

		strongSlider.mount();
	}

	// creativeService スライダー（スマホモックアップ内 + カスタムドット）
	const serviceSliderEl = document.querySelector('.js-service-slider');
	if (serviceSliderEl) {
		const dotsWrap = serviceSliderEl.querySelector('.creativeService__dots');
		const slideCount = serviceSliderEl.querySelectorAll('.splide__slide').length;

		// カスタムドットを生成
		if (dotsWrap) {
			for (let i = 0; i < slideCount; i++) {
				const btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'creativeService__dot' + (i === 0 ? ' is-active' : '');
				btn.setAttribute('aria-label', (i + 1) + '枚目のスライドへ');
				btn.setAttribute('role', 'tab');
				btn.dataset.index = String(i);
				dotsWrap.appendChild(btn);
			}
		}

		const serviceSlider = new window.Splide(serviceSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});

		// ドットクリックでスライド移動
		if (dotsWrap) {
			dotsWrap.addEventListener('click', function (e) {
				const btn = e.target.closest('.creativeService__dot');
				if (btn) serviceSlider.go(Number(btn.dataset.index));
			});
		}

		// スライド変更でドットのアクティブ状態を同期
		serviceSlider.on('moved', function (newIndex) {
			if (!dotsWrap) return;
			dotsWrap.querySelectorAll('.creativeService__dot').forEach(function (dot, i) {
				dot.classList.toggle('is-active', i === newIndex);
			});
		});

		serviceSlider.mount();
	}

	// creativeFlow スライダー（Step タブ + スライド）
	const flowSliderEl = document.querySelector('.js-flow-slider');
	const flowTabs = document.querySelectorAll('.js-flow-tab');
	if (flowSliderEl && flowTabs.length) {
		const flowSlider = new window.Splide(flowSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: false,
			autoplay: false,
		});

		flowTabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				flowSlider.go(Number(tab.dataset.index));
			});
		});

		flowSlider.on('moved', function (newIndex) {
			flowTabs.forEach(function (tab, i) {
				const isActive = i === newIndex;
				tab.classList.toggle('creativeFlow__tab--current', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
			const tabsEl = document.querySelector('.js-flow-tabs');
			if (tabsEl) tabsEl.setAttribute('data-current', String(newIndex));
		});

		flowSlider.mount();
	}

	// 導入事例カード「めくる」スライダー
	const caseSliderEl = document.querySelector('.js-case-slider');
	const caseFlipBtn = document.querySelector('.js-case-flip');
	if (caseSliderEl && caseFlipBtn) {
		const caseSlider = new window.Splide(caseSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 0,          // CSS トランジションで制御するため Splide の speed は 0
			pagination: false,
			arrows: false,
			drag: false,
		});

		// フリップ（めくり）アニメーション
		const FLIP_DURATION = 600; // ms
		let isFlipping = false;

		caseFlipBtn.addEventListener('click', function () {
			if (isFlipping) return;
			isFlipping = true;

			const track = caseSliderEl.querySelector('.c-caseSlide__slideTrack');
			track.classList.add('is-flipping');

			// 半分(前面→側面)でスライドを切り替える
			setTimeout(function () {
				caseSlider.go('>');
			}, FLIP_DURATION / 2);

			// アニメーション完了後にクラスを外す
			setTimeout(function () {
				track.classList.remove('is-flipping');
				isFlipping = false;
			}, FLIP_DURATION);
		});

		caseSlider.mount();

		// Splide が track に overflow を付与するため、box-shadow が見えるよう上書き
		const track = caseSliderEl.querySelector('.splide__track');
		if (track) track.style.overflow = 'visible';
	}

	initTopRecommendedFeaturesSlider();
	initTopPropertySlider();
	initTopVoiceSlider();
	initBukkenListCards();
	initBukkenDetailSliders();
	initBukkenDetailSimilarSlider();
	initBukkenDetailVoice();
	initStoreDetailSlider();
}

const TOP_CAROUSEL_MIN_SLIDES_FOR_ARROWS = 4;

function shouldShowTopCarouselArrows(slider, minCount = TOP_CAROUSEL_MIN_SLIDES_FOR_ARROWS) {
	if (slider.length < minCount) return false;
	return slider.root.classList.contains('is-overflow');
}

function updateTopCarouselNav(slider, section) {
	if (!section) return;

	const arrowsWrap = section.querySelector('[class*="__arrows"]');
	const prevBtn = section.querySelector('.splide__arrow--prev');
	const nextBtn = section.querySelector('.splide__arrow--next');
	const show = shouldShowTopCarouselArrows(slider);

	if (arrowsWrap) {
		arrowsWrap.classList.toggle('is-hidden', !show);
	}

	if (!show) return;

	const end = slider.Components.Controller.getEnd();
	if (prevBtn) prevBtn.disabled = slider.index <= 0;
	if (nextBtn) nextBtn.disabled = slider.index >= end;
}

function bindTopCarouselNav(slider, section) {
	const prevBtn = section ? section.querySelector('.splide__arrow--prev') : null;
	const nextBtn = section ? section.querySelector('.splide__arrow--next') : null;
	if (prevBtn) prevBtn.addEventListener('click', () => slider.go('<'));
	if (nextBtn) nextBtn.addEventListener('click', () => slider.go('>'));

	const update = () => updateTopCarouselNav(slider, section);
	slider.on('mounted refresh resized updated move moved', update);
	update();
}

function initTopHorizontalCarousel(el, getSlideWidthPx, breakpoint768Options = {}) {
	const slider = new window.Splide(el, {
		type: 'slide',
		rewind: false,
		fixedWidth: getSlideWidthPx(),
		perMove: 1,
		gap: 0,
		padding: { left: 0, right: 0 },
		arrows: false,
		pagination: false,
		drag: true,
		trimSpace: false,
		breakpoints: {
			768: {
				fixedWidth: getSlideWidthPx(),
				gap: 0,
				padding: { left: 0, right: 0 },
				...breakpoint768Options,
			},
		},
	});
	slider.mount();

	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			const w = getSlideWidthPx();
			slider.options = { ...slider.options, fixedWidth: w };
			slider.refresh();
		}, 100);
	});

	const section = el.closest('.topRecommendedFeatures, .topProperty');
	bindTopCarouselNav(slider, section);
	return slider;
}

/**
 * おすすめ特集（topRecommendedFeatures）カルーセル
 * 左端基準・ウィンドウ幅に応じて右方向にスライド表示
 * SP: スライド幅は get_vw(350) に相当する px（viewport 390 基準）を JS で算出して fixedWidth に反映
 */
function getTopRecommendedFeaturesSlideWidthPx() {
	return window.innerWidth <= 768
		? Math.round((350 / 390) * window.innerWidth)
		: 496;
}

function initTopRecommendedFeaturesSlider() {
	const el = document.querySelector('.js-top-recommended-features-slider');
	if (!el) return;

	initTopHorizontalCarousel(el, getTopRecommendedFeaturesSlideWidthPx, { perPage: 1 });
}

/**
 * タカマツハウス不動産限定物件・おすすめ物件（topProperty）カルーセル
 * 共通の JS で複数セクションを初期化
 * SP: スライド幅は get_vw(350) に相当する px（viewport 390 基準）を JS で算出して fixedWidth に反映
 */
function getTopPropertySlideWidthPx() {
	return window.innerWidth <= 768
		? Math.round((350 / 390) * window.innerWidth)
		: 416;
}

function initTopPropertySlider() {
	const els = document.querySelectorAll('.js-top-property-slider');
	els.forEach(function (el) {
		initTopHorizontalCarousel(el, getTopPropertySlideWidthPx);
	});
}

/**
 * 物件詳細ページの類似物件スライダー（条件が似ている物件・同じ駅の物件・価格が近い物件）
 * 同じ設定で3つ初期化。スライド幅は getTopPropertySlideWidthPx と同様。
 */
function getBukkenDetailSimilarSlideWidthPx() {
	return window.innerWidth <= 768
		? Math.round((252 / 390) * window.innerWidth)
		: 260;
}

function updateBukkenDetailSimilarNav(slider, wrap) {
	if (!wrap) return;

	const prevBtn = wrap.querySelector('.bukkenDetail__similarSliderArrow--prev');
	const nextBtn = wrap.querySelector('.bukkenDetail__similarSliderArrow--next');
	const show = slider.root.classList.contains('is-overflow');
	const end = slider.Components.Controller.getEnd();

	if (prevBtn) {
		prevBtn.hidden = !show;
		prevBtn.disabled = !show || slider.index <= 0;
	}
	if (nextBtn) {
		nextBtn.hidden = !show;
		nextBtn.disabled = !show || slider.index >= end;
	}
}

function bindBukkenDetailSimilarNav(slider, wrap) {
	const prevBtn = wrap ? wrap.querySelector('.bukkenDetail__similarSliderArrow--prev') : null;
	const nextBtn = wrap ? wrap.querySelector('.bukkenDetail__similarSliderArrow--next') : null;
	if (prevBtn) prevBtn.addEventListener('click', () => slider.go('<'));
	if (nextBtn) nextBtn.addEventListener('click', () => slider.go('>'));

	const update = () => updateBukkenDetailSimilarNav(slider, wrap);
	slider.on('mounted refresh resized updated move moved', update);
	update();
}

function initBukkenDetailSimilarSlider() {
	const els = document.querySelectorAll('.js-bukken-detail-similar-slider');
	els.forEach(function (el) {
		const similarSlider = new window.Splide(el, {
			type: 'slide',
			rewind: false,
			fixedWidth: getBukkenDetailSimilarSlideWidthPx(),
			perMove: 1,
			gap: 0,
			padding: { left: 0, right: 0 },
			arrows: false,
			pagination: false,
			drag: true,
			trimSpace: false,
			breakpoints: {
				768: {
					fixedWidth: getBukkenDetailSimilarSlideWidthPx(),
					gap: 0,
					padding: { left: 0, right: 0 },
				},
			},
		});
		similarSlider.mount();

		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				const w = getBukkenDetailSimilarSlideWidthPx();
				similarSlider.options = { ...similarSlider.options, fixedWidth: w };
				similarSlider.refresh();
			}, 100);
		});

		const wrap = el.closest('.bukkenDetail__similarSliderWrap');
		bindBukkenDetailSimilarNav(similarSlider, wrap);
	});
}

/**
 * お客様の声（topVoice）カルーセル - 引用文の高さ揃え
 * SP: スライド幅は get_vw(320) に相当する px（viewport 390 基準）を JS で算出して fixedWidth に反映
 */
function getTopVoiceSlideWidthPx() {
	return window.innerWidth <= 768
		? Math.round((320 / 390) * window.innerWidth)
		: 586;
}

function matchHeightTopVoiceQuote(sliderEl) {
	const container = sliderEl ? sliderEl.closest('.topVoice') : document.querySelector('.topVoice');
	if (!container) return;
	const quotes = container.querySelectorAll('.topVoice__quoteBlock.js-matchheight');
	if (!quotes.length) return;

	quotes.forEach((el) => {
		el.style.height = '';
		el.style.minHeight = '';
	});

	const maxHeight = Math.max(...Array.from(quotes).map((el) => el.offsetHeight));
	quotes.forEach((el) => {
		el.style.minHeight = `${maxHeight}px`;
	});
}

function initTopVoiceSlider() {
	const el = document.querySelector('.js-top-voice-slider');
	if (!el) return;

	truncateTopVoiceQuotes(el);

	const slider = new window.Splide(el, {
		type: 'loop',
		rewind: true,
		fixedWidth: getTopVoiceSlideWidthPx(),
		perMove: 1,
		gap: 0,
		padding: { left: 0, right: 0 },
		arrows: false,
		pagination: false,
		drag: true,
		trimSpace: false,
		breakpoints: {
			768: {
				fixedWidth: getTopVoiceSlideWidthPx(),
				gap: 0,
				padding: { left: 0, right: 0 },
			},
		},
	});

	slider.on('mounted', () => {
		truncateTopVoiceQuotes(el);
		matchHeightTopVoiceQuote(el);
	});

	slider.mount();

	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			const w = getTopVoiceSlideWidthPx();
			slider.options = { ...slider.options, fixedWidth: w };
			slider.refresh();
			truncateTopVoiceQuotes(el);
			matchHeightTopVoiceQuote(el);
		}, 100);
	});

	const section = el.closest('.topVoice');
	const prevBtn = section ? section.querySelector('.splide__arrow--prev') : null;
	const nextBtn = section ? section.querySelector('.splide__arrow--next') : null;
	if (prevBtn) prevBtn.addEventListener('click', () => slider.go('<'));
	if (nextBtn) nextBtn.addEventListener('click', () => slider.go('>'));
}

/** 物件一覧 / お気に入り: カード内スライダー用（接頭辞が異なる同一マークアップ） */
function qsBukkenOrFavorite(sliderEl, suffix) {
	const b = sliderEl.querySelector('.bukkenList__' + suffix);
	if (b) return b;
	return sliderEl.querySelector('.favorite__' + suffix);
}

function closestBukkenOrFavoriteCard(sliderEl) {
	return sliderEl.closest('.bukkenList__card') || sliderEl.closest('.favorite__card');
}

/**
 * 物件一覧カード: 画像スライダー（カードごとに個別）、ページ表示 1/31、チェック・お気に入りトグル
 */
function initBukkenListCards() {
	const listFloorModal = document.getElementById('bukken-list-floor-modal');
	const sliderEls = document.querySelectorAll('.js-bukken-card-slider');
	sliderEls.forEach(function (sliderEl) {
		const card = closestBukkenOrFavoriteCard(sliderEl);
		if (!card) return;
		const total = sliderEl.getAttribute('data-slide-total') || '';
		const pageTotalEl = qsBukkenOrFavorite(sliderEl, 'cardPageTotal');
		if (pageTotalEl && total) pageTotalEl.textContent = total;

		const slider = new window.Splide(sliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: true,
		});
		slider.on('moved', function (newIndex) {
			const currentEl = qsBukkenOrFavorite(sliderEl, 'cardPageCurrent');
			if (currentEl) currentEl.textContent = newIndex + 1;
		});
		slider.mount();

		const prevBtn = qsBukkenOrFavorite(sliderEl, 'cardArrow--prev');
		const nextBtn = qsBukkenOrFavorite(sliderEl, 'cardArrow--next');
		const layoutBtn = qsBukkenOrFavorite(sliderEl, 'cardLayoutBtn');
		if (prevBtn) prevBtn.addEventListener('click', function () { slider.go('<'); });
		if (nextBtn) nextBtn.addEventListener('click', function () { slider.go('>'); });
		if (layoutBtn && !listFloorModal) {
			layoutBtn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				slider.go(1);
			});
		}
	});

	function syncFloatInquiryBtnVisibility() {
		const wrap = document.querySelector('.bukkenList__floatBtnWrap');
		if (!wrap) return;
		const checked = document.querySelectorAll(
			'.bukkenList__cardCheck.is-checked, .favorite__cardCheck.is-checked'
		);
		const show = checked.length > 0;
		wrap.classList.toggle('is-hidden', !show);
		wrap.setAttribute('aria-hidden', show ? 'false' : 'true');
	}

	document.querySelectorAll('.bukkenList__cardCheck, .favorite__cardCheck').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const pressed = this.getAttribute('aria-pressed') !== 'true';
			this.classList.toggle('is-checked', pressed);
			this.setAttribute('aria-pressed', pressed ? 'true' : 'false');
			syncFloatInquiryBtnVisibility();
		});
	});
	syncFloatInquiryBtnVisibility();
	document.querySelectorAll('.bukkenList__cardFavorite, .favorite__cardFavorite, .staffRecommendCard__favorite').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const pressed = this.getAttribute('aria-pressed') !== 'true';
			this.classList.toggle('is-favorite', pressed);
			this.setAttribute('aria-pressed', pressed ? 'true' : 'false');
		});
	});
}

/**
 * 店舗詳細: メイン（フェード）+ サムネ Splide。物件詳細と同様に手動同期 + サムネホバーでメイン追従。
 */
function initStoreDetailSlider() {
	const mainEl = document.getElementById('store-detail-main');
	const thumbEl = document.getElementById('store-detail-thumb');
	if (!mainEl || !thumbEl) return;

	let ignoreNextThumbMoved = false;

	const mainSlider = new window.Splide(mainEl, {
		type: 'fade',
		rewind: true,
		speed: 400,
		pagination: false,
		arrows: false,
		drag: true,
	});
	const thumbSlider = new window.Splide(thumbEl, {
		gap: 24,
		perPage: 4,
		// perPage のみだと横並びリストの幅計測に依存し、SP Safari で refresh が重なるとスライド高さが異常値になることがあるため明示する（物件詳細サムネと同様）
		fixedHeight: 101,
		rewind: true,
		pagination: false,
		arrows: false,
		cover: true,
		isNavigation: true,
		breakpoints: {
			768: {
				gap: 11,
				perPage: 4,
				fixedHeight: '11.4vw',
			},
		},
	});

	mainSlider.mount();
	thumbSlider.mount();

	function refreshStoreDetailThumb() {
		thumbSlider.refresh();
	}

	// SP Safari ではリロード直後にサムネ幅が 0 のまま mount されることがある。メインも refresh すると計測が干渉しうるためサムネのみ再計算する
	requestAnimationFrame(function () {
		requestAnimationFrame(refreshStoreDetailThumb);
	});
	window.addEventListener('load', refreshStoreDetailThumb, { once: true });
	window.addEventListener(
		'pageshow',
		function () {
			requestAnimationFrame(refreshStoreDetailThumb);
		},
		{ passive: true }
	);
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function () {
			requestAnimationFrame(refreshStoreDetailThumb);
		});
	}

	thumbEl.addEventListener(
		'click',
		function (e) {
			e.preventDefault();
			e.stopPropagation();
		},
		true
	);

	function syncThumbButtons(activeIndex) {
		const slides = thumbEl.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
		slides.forEach(function (slide, i) {
			const btn = slide.querySelector('.storeDetail__thumbBtn');
			if (!btn) return;
			const on = i === activeIndex;
			btn.classList.toggle('is-active', on);
			btn.setAttribute('aria-pressed', on ? 'true' : 'false');
		});
	}

	mainSlider.on('moved', function (newIndex) {
		syncThumbButtons(newIndex);
		if (thumbSlider.index !== newIndex) {
			ignoreNextThumbMoved = true;
			thumbSlider.go(newIndex);
			queueMicrotask(function () {
				if (ignoreNextThumbMoved) ignoreNextThumbMoved = false;
			});
		}
	});

	thumbSlider.on('moved', function (newIndex) {
		if (ignoreNextThumbMoved) {
			ignoreNextThumbMoved = false;
			return;
		}
		if (mainSlider.index !== newIndex) {
			mainSlider.go(newIndex);
		}
	});

	syncThumbButtons(0);
	bindBukkenDetailThumbHoverPreview(mainSlider, thumbEl);
}

/**
 * 物件詳細: メイン + サムネ Splide。isNavigation: true を維持（ARIA 等）。
 * sync() は使わず手動同期。サムネクリックは無効、PCホバーのみメイン切替。
 * サムネ帯は active が見えている間は動かさず、見切れたときだけ1枚分ずらす。
 * 帯の index は左端位置のため、thumbSlider の moved ではメインを同期しない。
 * メインの rewind（先頭／末尾）時は帯をジャンプで合わせる。
 */
function initBukkenDetailSliders() {
	const mainEl = document.getElementById('bukken-detail-main');
	const thumbEl = document.getElementById('bukken-detail-thumb');
	if (!mainEl || !thumbEl) return;

	let skipThumbStripSync = false;
	let lastMainNavDirection = null;

	function getThumbListSlides() {
		return thumbEl.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
	}

	function getThumbTrackEl() {
		return thumbEl.querySelector('.splide__track');
	}

	function isBukkenThumbSlideVisible(index) {
		const slides = getThumbListSlides();
		const slide = slides[index];
		const track = getThumbTrackEl();
		if (!slide || !track) return false;
		const trackRect = track.getBoundingClientRect();
		const slideRect = slide.getBoundingClientRect();
		return slideRect.right > trackRect.left && slideRect.left < trackRect.right;
	}

	function inferMainNavDirection(newIndex, prevIndex, slideCount) {
		if (prevIndex == null || slideCount <= 1) return 0;
		if (prevIndex === slideCount - 1 && newIndex === 0) return 1;
		if (prevIndex === 0 && newIndex === slideCount - 1) return -1;
		if (newIndex > prevIndex) return 1;
		if (newIndex < prevIndex) return -1;
		return 0;
	}

	function scrollThumbStripOneStep(direction) {
		if (!direction) return;
		thumbSlider.go(direction > 0 ? '+' : '-');
	}

	function getThumbSlideStep() {
		const slides = getThumbListSlides();
		if (slides.length === 0) return 0;
		if (slides.length === 1) return slides[0].getBoundingClientRect().width;
		const first = slides[0].getBoundingClientRect();
		const second = slides[1].getBoundingClientRect();
		return second.left - first.left;
	}

	function getThumbStripVisibleCount() {
		const track = getThumbTrackEl();
		const step = getThumbSlideStep();
		if (!track || step <= 0) {
			return thumbSlider.options.perPage || 1;
		}
		const trackWidth = track.getBoundingClientRect().width;
		return Math.max(1, Math.floor(trackWidth / step));
	}

	/** メイン index のサムネが帯内に入るよう左端 index へジャンプ（巻き戻し時など） */
	function scrollThumbStripToShowIndex(targetIndex, align) {
		const count = getThumbListSlides().length;
		if (count <= 0) return;
		if (targetIndex <= 0) {
			if (thumbSlider.index !== 0) thumbSlider.go(0);
			return;
		}
		const visibleCount = getThumbStripVisibleCount();
		const maxStart = Math.max(0, count - visibleCount);
		const start =
			align === 'start'
				? Math.min(targetIndex, maxStart)
				: Math.max(0, targetIndex - visibleCount + 1);
		if (thumbSlider.index !== start) {
			thumbSlider.go(start);
		}
	}

	/** 見切れ時: 1枚分ずらせる場合のみ ±1、それ以外は最小ジャンプ */
	function scrollThumbStripIfNeeded(newIndex, direction) {
		if (isBukkenThumbSlideVisible(newIndex)) return;

		const visibleCount = getThumbStripVisibleCount();
		const stripStart = thumbSlider.index;
		const stripEnd = stripStart + visibleCount - 1;

		if (newIndex < stripStart) {
			const offBy = stripStart - newIndex;
			if (offBy === 1 && direction < 0) {
				scrollThumbStripOneStep(-1);
			} else {
				scrollThumbStripToShowIndex(newIndex, 'start');
			}
			return;
		}

		if (newIndex > stripEnd) {
			const offBy = newIndex - stripEnd;
			if (offBy === 1 && direction > 0) {
				scrollThumbStripOneStep(1);
			} else {
				scrollThumbStripToShowIndex(newIndex, 'end');
			}
		}
	}

	function goMainByArrow(direction) {
		lastMainNavDirection = direction;
		mainSlider.go(direction > 0 ? '>' : '<');
	}

	function syncThumbActiveState(activeIndex) {
		getThumbListSlides().forEach(function (slide, i) {
			slide.classList.toggle('is-active', i === activeIndex);
		});
	}

	function goToBukkenDetailIndex(index, options) {
		const syncThumbStrip = !options || options.syncThumbStrip !== false;
		if (mainSlider.index === index) {
			syncThumbActiveState(index);
			return;
		}
		if (!syncThumbStrip) {
			skipThumbStripSync = true;
		}
		mainSlider.go(index);
	}

	const total = mainEl.querySelectorAll('.splide__slide').length;
	const pageTotalEl = mainEl.querySelector('.bukkenDetail__pageTotal');
	if (pageTotalEl) pageTotalEl.textContent = String(total);

	const mainSlider = new window.Splide(mainEl, {
		type: 'fade',
		rewind: true,
		speed: 400,
		pagination: false,
		arrows: false,
		drag: true,
	});
	const thumbSlider = new window.Splide(thumbEl, {
		fixedWidth: 109,
		fixedHeight: 78,
		perPage: 9,
		gap: 0,
		rewind: true,
		pagination: false,
		arrows: false,
		cover: true,
		isNavigation: true,
		breakpoints: {
			768: {
				fixedWidth: '26.5vw',
				fixedHeight: '20vw',
				gap: '2.5vw',
			},
		},
	});

	mainSlider.mount();
	thumbSlider.mount();

	// isNavigation のクリック同期を抑止（サムネ帯の大きなスクロールを防ぐ）。PC はホバーのみでメイン切替
	thumbEl.addEventListener(
		'click',
		function (e) {
			e.preventDefault();
			e.stopPropagation();
		},
		true
	);

	initBukkenDetailMainCaption(mainEl, mainSlider, thumbEl);
	bindBukkenDetailThumbInteraction(thumbEl, goToBukkenDetailIndex);

	mainSlider.on('moved', function (newIndex, prevIndex) {
		const currentEl = mainEl.querySelector('.bukkenDetail__pageCurrent');
		if (currentEl) currentEl.textContent = String(newIndex + 1);
		syncThumbActiveState(newIndex);
		if (skipThumbStripSync) {
			skipThumbStripSync = false;
			return;
		}
		const isRewindToStart = prevIndex === total - 1 && newIndex === 0;
		const isRewindToEnd = prevIndex === 0 && newIndex === total - 1;
		if (isRewindToStart || isRewindToEnd) {
			lastMainNavDirection = null;
			scrollThumbStripToShowIndex(newIndex, isRewindToStart ? 'start' : 'end');
			return;
		}
		if (isBukkenThumbSlideVisible(newIndex)) {
			lastMainNavDirection = null;
			return;
		}
		let direction = lastMainNavDirection;
		lastMainNavDirection = null;
		if (direction == null) {
			direction = inferMainNavDirection(newIndex, prevIndex, total);
		}
		scrollThumbStripIfNeeded(newIndex, direction);
	});

	// Splide isNavigation が帯 index 基準で is-active を付け直すため、メイン index で再同期
	thumbSlider.on('moved', function () {
		syncThumbActiveState(mainSlider.index);
	});

	syncThumbActiveState(0);

	const section = mainEl.closest('.bukkenDetail__sliderBlock');
	const prevArr = section ? section.querySelector('.bukkenDetail__arrow--prev') : null;
	const nextArr = section ? section.querySelector('.bukkenDetail__arrow--next') : null;
	if (prevArr) prevArr.addEventListener('click', () => goMainByArrow(-1));
	if (nextArr) nextArr.addEventListener('click', () => goMainByArrow(1));

	const thumbPrev = section ? section.querySelector('.bukkenDetail__thumbArrow--prev') : null;
	const thumbNext = section ? section.querySelector('.bukkenDetail__thumbArrow--next') : null;
	if (thumbPrev) thumbPrev.addEventListener('click', () => goMainByArrow(-1));
	if (thumbNext) thumbNext.addEventListener('click', () => goMainByArrow(1));
}

/**
 * 物件詳細: PCホバーのみでメイン画像を切り替え（クリックは無効）
 */
function bindBukkenDetailThumbInteraction(thumbRootEl, goToIndex) {
	function getListSlides() {
		return thumbRootEl.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
	}

	if (!window.matchMedia('(min-width: 768px)').matches) return;

	getListSlides().forEach(function (slide, index) {
		const btn = slide.querySelector('.bukkenDetail__thumb');
		if (!btn) return;
		btn.addEventListener('mouseenter', function () {
			goToIndex(index, { syncThumbStrip: false });
		});
	});
}

/**
 * 物件詳細: サムネホバーでメイン＋サムネを同期（is-active 追従）。マウスアウトでは元に戻さず、そのまま確定。
 */
function bindBukkenDetailThumbHoverPreview(mainSlider, thumbRootEl) {
	function getListSlides() {
		return thumbRootEl.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
	}

	function onThumbSlideEnter(e) {
		const slideEl = e.currentTarget;
		if (!slideEl.classList.contains('splide__slide')) return;
		const slides = getListSlides();
		const index = Array.prototype.indexOf.call(slides, slideEl);
		if (index < 0) return;
		mainSlider.go(index);
	}

	getListSlides().forEach(function (slide) {
		slide.addEventListener('mouseenter', onThumbSlideEnter);
	});
}

/**
 * 物件詳細: お客様の声スライダー（カルーセル）
 */
function getBukkenDetailVoiceSlideWidthPx() {
	return window.innerWidth <= 768
		? Math.round((260 / 390) * window.innerWidth)
		: 260;
}

function initBukkenDetailVoice() {
	const el = document.querySelector('.js-bukken-detail-voice');
	if (!el) return;

	const slider = new window.Splide(el, {
		type: 'loop',
		rewind: true,
		fixedWidth: getBukkenDetailVoiceSlideWidthPx(),
		perMove: 1,
		gap: 10,
		padding: { left: 0, right: 0 },
		arrows: false,
		pagination: false,
		drag: true,
		trimSpace: false,
		breakpoints: {
			768: {
				fixedWidth: getBukkenDetailVoiceSlideWidthPx(),
				gap: getBukkenDetailVoiceSlideWidthPx() * 0.04,
			},
		},
	});
	slider.mount();

	const section = el.closest('.bukkenDetail__voice');
	const prevBtn = section ? section.querySelector('.bukkenDetail__voiceArrow--prev') : null;
	const nextBtn = section ? section.querySelector('.bukkenDetail__voiceArrow--next') : null;
	if (prevBtn) prevBtn.addEventListener('click', () => slider.go('<'));
	if (nextBtn) nextBtn.addEventListener('click', () => slider.go('>'));
}
